import { useEffect, useState } from 'react'
import { api } from '../../lib/api'

// Read once for the subject, so the maker and signer walls can be applied
// before a button is pressed.
export function useSubject(): string {
  const [subject, setSubject] = useState('')
  useEffect(() => {
    let live = true
    api
      .me()
      .then((m) => {
        if (live) setSubject(m.subject)
      })
      .catch(() => undefined)
    return () => {
      live = false
    }
  }, [])
  return subject
}

// The last value that was not null.
//
// A drawer opened for one row slides away over 240 ms after the row is let go.
// Rendering it from the value the caller has just cleared would empty it
// mid-slide, so the drawer keeps what it was opened with until it is opened
// for something else.
export function useKept<T>(value: T | null): T | null {
  const [kept, setKept] = useState<T | null>(value)
  useEffect(() => {
    if (value !== null) setKept(value)
  }, [value])
  return value ?? kept
}
